<template>
	<div class="loading" v-if="visible">
		<img class="loadingGif" src="https://file.wenms.com/SchoolService/images/loading.gif" />
	</div>
</template>

<script>
	export default {
		name: 'loading',
		data() {
			return {
				visible: false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.loading {
		position: fixed;
		left: 0;
		top: 52px;
		right: 0;
		bottom: 0;
		z-index: 9999999;
		//background: rgba(255, 255, 255, 0.3);
		-webkit-user-select:none;
		-moz-user-select:none;
		-ms-user-select:none;
		user-select:none;
	}

	.loadingGif {
		position: absolute;
		left: 50%;
		top: 40%;
		width: 90px;
		transform: translate(-50%, -50%);
	}
</style>